<script>
import api from '@modules/JourneyBuilder/api';

import { brickDefinitions } from "@modules/JourneyBuilder/Bricks/brick-definitions";
import brickTypes from '@modules/JourneyBuilder/Bricks/brick-types';

import iconAbTest from '@modules/JourneyBuilder/Assets/Bricks/icon-ab-test.svg?component';
import iconAudienceFilter from '@modules/JourneyBuilder/Assets/Bricks/icon-audience-filter.svg?component';

export default {
    name: "BrickIcon",

    props: {
        brickType: {
            type: Number,
            required: true
        },
        
        brickConfig: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },
    
    data() {
        return {
            remoteSvg: null
        }
    },
    
    computed: {
        staticSvgComponent() {
            switch (this.brickType){
                case brickTypes.audienceFilter:
                    return iconAudienceFilter;
                case brickTypes.abTest:
                    return iconAbTest;
                default:
                    return undefined;
            }
        },
        
        iconClass() {
            return this.brickConfig.icon || brickDefinitions[this.brickType].icon;
        }
    },
    
    created() {
        this.loadRemoteSvg();
    },
    
    watch: {
        'brickConfig.touchpointVariation'(){
            this.loadRemoteSvg();
        }
    },
    
    methods: {
        async loadRemoteSvg() {
            //Remote SVGs are based on our brick touchpointVariation
            //when our touchpointVariation is a falsey, it's not relevant
            //and we can simply use a 'standard' icon
            if(!this.brickConfig.touchpointVariation) {
                this.remoteSvg = null;
                return;
            }
            
            //If our brick has a touchpointVariation, it is safe to make the assumption that our brick is a touchpoint
            //and will thus have a valid touchPointTypeId
            try {
                const touchpointTypes = await api.getTouchpointTypes();

                const brickTouchpointType = touchpointTypes.find(tt => tt.id === this.brickConfig.touchPointTypeId);
                const variation = brickTouchpointType.variation.find(v => v.name === this.brickConfig.touchpointVariation)

                //variation.icon may be either a NULL value, or an SVG document
                this.remoteSvg = variation.icon;
            } catch(e) {
                //Swallow - our icon (likely) does not exist
                this.remoteSvg = null;
            }
        }
    },
    
    render(createElement) {
        if(this.staticSvgComponent) {
            return createElement(this.staticSvgComponent);
        }
        
        if(this.remoteSvg) {
            return createElement('div', {
                domProps: {
                    innerHTML: this.remoteSvg
                }
            });
        }

        return createElement('i', {
            class: this.iconClass
        });
    }
}
</script>
